import { setFilter, setFilters } from 'actions/search';
import { getFilter } from 'selectors/search';

export const CORE_ACTIVITY_CODE = 'P30 - Center Core Grants';

export const getPresetFilterDefaults = filters => {
  const defaults = {};

  if (filters?.kol === true) {
    // Only fill values the caller hasn't explicitly provided — an AI query like
    // "KOLs with 50+ publications" must not be clamped back to the preset defaults.
    if (filters.totalPublications === undefined) {
      defaults.totalPublications = 10;
    }
    if (filters.threeYearHIndexAverage === undefined) {
      defaults.threeYearHIndexAverage = 300;
    }
  }

  return defaults;
};

export const applyPresetSideEffects = filters => (dispatch, getState) => {
  const defaults = getPresetFilterDefaults(filters);
  if (Object.keys(defaults).length > 0) {
    dispatch(setFilters(defaults));
  }

  if (filters?.core === undefined) return;

  const current = getFilter('nihActivityCode')(getState()) || [];
  const hasP30 = current.includes(CORE_ACTIVITY_CODE);
  const shouldHaveP30 = filters.core === true;

  if (shouldHaveP30 && !hasP30) {
    dispatch(setFilter('nihActivityCode', [...current, CORE_ACTIVITY_CODE]));
  } else if (!shouldHaveP30 && hasP30) {
    const next = current.filter(v => v !== CORE_ACTIVITY_CODE);
    dispatch(setFilter('nihActivityCode', next.length ? next : null));
  }
};
